const ADD_MODEL_OF_TYPE = 'addModelOfType';
const INIT_FORM = 'initForm';
const STOP_FORM = 'stopForm';
const SET_CURRENT_STEP = 'setCurrentStep';
const CREATE_VALUE_FIELD = 'createValue';
const CHANGE_VALUE_FIELD = 'onChange';
const CHANGE_VALIDATIONS_STATES = 'changeValidationsStates';
const INIT_VALIDATION = 'initValidation';
const ADD_STEP_TO_HISTORIC = 'addStepToHistoric';
const DELETE_LAST_FROM_HISTORIC = 'deleteLastFromHistoric';
const CLEAR_HISTORIC_UNTIL_STEP = 'clearHistoricUntilStep';
const RESET_FORM = 'resetForm';
const ROUTE_CHANGE_FORM = 'routeChangeForm';
const ROUTE_GO_TO_END_PAGE = 'routeGoToEndPage';
const SETUP_FLOW_MANAGER = 'setupFlowManager';
const INIT_FLOW_MANAGER = 'initFlowManager';
const SET_RESPONSE_PARAMS = 'setResponseParams';
const CLEAR_ALL_HISTORIC = 'clearAllHistoric';
const MODAL_OVERLAY = 'modalOverlay';
const SET_APP_ID = 'setAppId';
const SET_SHOW_API_PANEL = 'setShowApiPanel';
const UPDATE_MODEL_OF_TYPE = 'UpdateModelOfType';
const SET_SERVICE_STATUS = 'setServiceStatus';
const SET_SERVICE_STATUS_REFERAL = 'setServiceStatusReferal';
const SET_MAX_LOAN = 'setMaxLoan';
const SET_MONTHLY_INSTALMENTS = 'setMonthlyInstalments';
const SET_TRANSACTION_ID = 'setTransactionId';
const SET_TRANSACTION_DECISION = 'setTransactionDecision';
const RESET_TRANSACTION_DECISION = 'resetTransactionDecision';
const SET_INSTITUTIONS = 'setInstitutions';
const SET_UPLOADED_OCR = 'setUploadedOCR';
const SET_LAST_VISITED_PAGE = 'setLastVisitedPage';
const ADD_SUPPLEMENTARY_CARD = 'addSUpplementaryCard';
const EDIT_SUPPLEMENTARY_CARD = 'editSupplementaryCard';
const SET_CURRENT_PRODUCT = 'setCurrentProduct';
const REMOVE_SUPPLEMENTARY_CARD = 'removeSupplementaryCard';
//Beging Changes done by Attra
const SET_QUERYSTRING = 'setQueryString';
const SET_CIF_NUMBER = 'setCifNumber';
const SET_INSTALMENT_AMOUNT = 'setInstalmentAmount';
const SET_UTM_SOURCE = 'setUtmSource';
const SET_UTM_MEDIUM = 'setUtmMedium';
const SET_UTM_CAMPAIGN = 'setUtmCampaign';
const SET_UTM_CONTENT = 'setUtmContent';
const SET_UTM_PRODUCT_ID = 'setUtmProductid';
const SET_BANK_NAME = 'setBankName';
const SET_CREDIT_SCORE_STATUS = 'setCreditScoreStatus';
const SET_DOC_NUMBER = 'setDocNumber';
const SET_DOC_TYPE = 'setDocType';
const SET_FIRST_NAME = 'setFirstName';
const SET_SECOND_NAME = 'setSecondName';
const SET_BASIC_ELIGIBILITY = 'setBasicEligibility'
const SET_PRODUCT_TYPE = 'setProductType';
const SET_USE = 'setUse';
const SET_HOW_MUCH = 'setHowMuch';
const SET_INSTALMENT = 'setInstalment';
const SET_OTHER = 'setOther';
const SET_CONSOLIDATED_STATEMENT_DATA = 'setConsolidatedStatementData';
const SET_STATEMENT_ONE_DATA = 'setStatementOneData';
const SET_STATEMENT_TWO_DATA = 'setStatementSecondData';
const SET_STATEMENT_THREE_DATA = 'setStatementThreeData';
const SET_CREDIT_SCORE_CALCULATION_STATUS = 'setCreditScoreCalculationStatus';
const SET_PRODCUT_FROM_URL = 'setProductFromUrl'
const SET_SPENDING = 'setSpending';
const SET_SALARY_RECEIVE = 'setSalaryRecive';
const SET_REWARD_TYPE = 'setRewardType';
const SET_CASH_BACK_POINT = 'setCashBackPoint';
const SET_TEN_TO_TWENTY_FIVE = 'setTenToTwentyFive';
const SET_MORE_THAN_TWENTY_FIVE = 'setMoreThanTwentyFive';
const SET_INELIGIBLE_EMIRATES = 'setIneligibleEmirates';
const SET_EMPLOYMENT_TYPE = 'setEmploymentType';
const SET_SERVICE_ERROR = 'setServiceError';
const SET_CARD_TYPE = 'setCardType';
const SET_LOAN_TYPE = 'setLoanType';
const SET_PROMO_CODE_RESPONSE = 'setPromoCodeResponse';
const SET_PROMO_CODE_STATUS = 'setPromoCodeStatus';
const SET_BRANCH_CODES = 'setBranchCodes';
const SET_EMPLOYEE_CODES = 'setEmployeeCodes';
const SET_PRODUCTS = 'setProducts';
const SET_INELIGIBLE_MEDIUM_OF_RECEIVE = 'setIneligibleMediumOfReceive';
const SET_APPIAN_PERSONAL_INFO_RESPONSE = 'setAppianPersonalInfoResponse';
const SET_APPIAN_IDENTITY_INFO_RESPONSE = 'setAppianIdentityInfoResponse';
const SET_APPIAN_EMP_INFO_RESPONSE = 'setAppianEmpInfoResponse';
const SET_APPIAN_INCOME_INFO_RESPONSE = 'setAppianIncomeInfoResponse';
const SET_PRODUCT_FROM_API_RESPONSE = 'setProductFromApiResponse';
const SET_OFFER_REJECTED = 'setOfferRejected';
const SET_IS_PERFIOS_ERROR = 'setIsPerfiosError';
const SET_PERFIOS_ERROR_MESSAGE = 'setPerfiosErrorMessage';
const SET_AGENT_MOBILE = 'setAgentMobile';
const SET_CARD_TYPE_APPIAN = 'setCardTypeAppian';
const SET_STP_CARD_INCOME_NEXT = 'setStpCardIncomeNext';
const SET_PRE_SCREENED_AMOUNT = 'setPreScreenedAmount';
const SET_VARIABLE_INCOME = 'setVariableIncome';
const SET_STP_PRE_SCREENED_AMOUNT = 'setStpPreScreenedAmount'
const SET_CHANNEL = 'setChannel'
const SET_ACCUITY_RESPONSE = 'setAccuityResponse';
const SET_UAE_VINTAGE = 'setUAEVintage';
const SET_CIF_ERROR = 'setCifError';
const SET_CUSTOMER_CONSENT = 'setCustomerConsent';
const SET_JOB_VINTAGE = 'setJobVintage';
const SET_CUSTOMER_EXIST = 'setCustomerExist';
const SET_CIF_ERROR_COUNT = 'setCifErrorCount';
const SET_CC_SCORE_RESPONSE = 'setCCScoreResponse';
const SET_MAX_CREDIT_LIMIT = 'setMaxCreditLimit';
const SET_APPLICATION_STATUS = 'setApplicationStatus';
const SET_REFERAL_CIF = 'setReferalCif';
const SET_CREDIT_SCORE_CALCULATION_RES = 'setCreditScoreCalculationRes';
const SET_ADDRESS_COUNT = 'setAddressCount';
const ADD_BALANCE_TRANSFER = 'addBalanceTransfer';
const EDIT_BALANCE_TRANSFER = 'editBalanceTransfer';
const REMOVE_BALANCE_TRANSFER = 'removeBalanceTransfer';
const SET_BUREAU_SCORE = 'setBureauScore';
const SET_INCOME_FIXED = 'setIncomeFixed';
const SET_BANK_NAMES = 'setBankName';
const SET_BT_TRANSFER_LIMIT = 'setBtTransferLimit';
const SET_LIMIT_EXCEEDED = 'setLimitExceeded';
const SET_AUTOMATION_RESPONSE = 'setAutomationResponse';
const SET_DEEMGUARD_CREDITLIFEPLUS = 'setDeemGuardCreditLife';
const SET_DEEM_DOUBLESECURE_LOANPROTECT = 'setDeemDoubleSecureLoanProtect';
//End Changes done by Attra

export {
    ADD_MODEL_OF_TYPE,
    INIT_FORM,
    SET_CURRENT_STEP,
    CREATE_VALUE_FIELD,
    CHANGE_VALUE_FIELD,
    CHANGE_VALIDATIONS_STATES,
    STOP_FORM,
    INIT_VALIDATION,
    ADD_STEP_TO_HISTORIC,
    DELETE_LAST_FROM_HISTORIC,
    CLEAR_HISTORIC_UNTIL_STEP,
    RESET_FORM,
    ROUTE_CHANGE_FORM,
    ROUTE_GO_TO_END_PAGE,
    SETUP_FLOW_MANAGER,
    INIT_FLOW_MANAGER,
    SET_RESPONSE_PARAMS,
    CLEAR_ALL_HISTORIC,
    MODAL_OVERLAY,
    SET_APP_ID,
    SET_SHOW_API_PANEL,
    UPDATE_MODEL_OF_TYPE,
    SET_SERVICE_STATUS,
    SET_MAX_LOAN,
    SET_MONTHLY_INSTALMENTS,
    SET_TRANSACTION_ID,
    SET_TRANSACTION_DECISION,
    SET_INSTITUTIONS,
    SET_UPLOADED_OCR,
    SET_LAST_VISITED_PAGE,
    ADD_SUPPLEMENTARY_CARD,
    EDIT_SUPPLEMENTARY_CARD,
    REMOVE_SUPPLEMENTARY_CARD,
    RESET_TRANSACTION_DECISION,
    SET_CURRENT_PRODUCT,
    SET_QUERYSTRING,
    SET_CIF_NUMBER,
    SET_INSTALMENT_AMOUNT,
    SET_UTM_SOURCE,
    SET_UTM_MEDIUM,
    SET_UTM_CAMPAIGN,
    SET_UTM_CONTENT,
    SET_UTM_PRODUCT_ID,
    SET_BANK_NAME,
    SET_CREDIT_SCORE_STATUS,
    SET_DOC_NUMBER,
    SET_FIRST_NAME,
    SET_SECOND_NAME,
    SET_BASIC_ELIGIBILITY,
    SET_PRODUCT_TYPE,
    SET_USE,
    SET_HOW_MUCH,
    SET_INSTALMENT,
    SET_OTHER,
    SET_CONSOLIDATED_STATEMENT_DATA,
    SET_STATEMENT_ONE_DATA,
    SET_STATEMENT_TWO_DATA,
    SET_STATEMENT_THREE_DATA,
    SET_CREDIT_SCORE_CALCULATION_STATUS,
    SET_PRODCUT_FROM_URL,
    SET_PROMO_CODE_RESPONSE,
    SET_PROMO_CODE_STATUS,
    //NBC CARD
    SET_SPENDING,
    SET_SALARY_RECEIVE,
    SET_REWARD_TYPE,
    SET_CASH_BACK_POINT,
    SET_TEN_TO_TWENTY_FIVE,
    SET_MORE_THAN_TWENTY_FIVE,
    SET_INELIGIBLE_EMIRATES,
    SET_EMPLOYMENT_TYPE,
    SET_SERVICE_ERROR,
    SET_CARD_TYPE,
    SET_LOAN_TYPE,
    SET_BRANCH_CODES,
    SET_EMPLOYEE_CODES,
    SET_PRODUCTS,
    SET_INELIGIBLE_MEDIUM_OF_RECEIVE,
    SET_APPIAN_PERSONAL_INFO_RESPONSE,
    SET_APPIAN_IDENTITY_INFO_RESPONSE,
    SET_APPIAN_EMP_INFO_RESPONSE,
    SET_APPIAN_INCOME_INFO_RESPONSE,
    SET_PRODUCT_FROM_API_RESPONSE,
    SET_OFFER_REJECTED,
    SET_IS_PERFIOS_ERROR,
    SET_PERFIOS_ERROR_MESSAGE,
    SET_SERVICE_STATUS_REFERAL,
    SET_AGENT_MOBILE,
    SET_CARD_TYPE_APPIAN,
    SET_STP_CARD_INCOME_NEXT,
    SET_PRE_SCREENED_AMOUNT,
    SET_VARIABLE_INCOME,
    SET_STP_PRE_SCREENED_AMOUNT,
    SET_CHANNEL,
    SET_ACCUITY_RESPONSE,
    SET_UAE_VINTAGE,
    SET_CIF_ERROR,
    SET_CUSTOMER_CONSENT,
    SET_JOB_VINTAGE,
    SET_CUSTOMER_EXIST,
    SET_CIF_ERROR_COUNT,
    SET_CC_SCORE_RESPONSE,
    SET_MAX_CREDIT_LIMIT,
    SET_APPLICATION_STATUS,
    SET_REFERAL_CIF,
    SET_CREDIT_SCORE_CALCULATION_RES,
    SET_ADDRESS_COUNT,
    ADD_BALANCE_TRANSFER,
    EDIT_BALANCE_TRANSFER,
    REMOVE_BALANCE_TRANSFER,
    SET_BUREAU_SCORE,
    SET_INCOME_FIXED,
    SET_BANK_NAMES,
    SET_BT_TRANSFER_LIMIT,
    SET_LIMIT_EXCEEDED,
    SET_AUTOMATION_RESPONSE,
    SET_DOC_TYPE,
    SET_DEEMGUARD_CREDITLIFEPLUS,
    SET_DEEM_DOUBLESECURE_LOANPROTECT

};